import {
  type ServiceHistory,
  ServiceHistorySchema,
  type ServiceIncident,
  ServiceIncidentSchema,
  type StatusCheckNow,
  type StatusCheckNowResponse,
  StatusCheckNowResponseSchema,
  type StatusIncidentsQuery,
  type StatusIncidentsResponse,
  StatusIncidentsResponseSchema,
  type StatusOverview,
  StatusOverviewSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const getStatusOverview = async (): Promise<StatusOverview> => {
  const { data } = await apiClient.get<unknown>('/status/overview');
  return StatusOverviewSchema.parse(data);
};

export const getServiceHistory = async (key: string): Promise<ServiceHistory> => {
  const { data } = await apiClient.get<unknown>(
    `/status/services/${encodeURIComponent(key)}/history`,
  );
  return ServiceHistorySchema.parse(data);
};

export const listStatusIncidents = async (
  query: Partial<StatusIncidentsQuery>,
): Promise<StatusIncidentsResponse> => {
  const { data } = await apiClient.get<unknown>('/status/incidents', { params: query });
  return StatusIncidentsResponseSchema.parse(data);
};

export const setIncidentNote = async (id: string, note: string): Promise<ServiceIncident> => {
  const { data } = await apiClient.patch<unknown>(`/status/incidents/${id}/note`, { note });
  return ServiceIncidentSchema.parse(data);
};

export const runStatusChecks = async (body: StatusCheckNow): Promise<StatusCheckNowResponse> => {
  const { data } = await apiClient.post<unknown>('/status/check-now', body);
  return StatusCheckNowResponseSchema.parse(data);
};
